import classNames from 'classnames';
import type { CSSProperties, JSX } from 'react';
import { useAnchorable } from '../../hooks/useAnchorable';
import { baseHeading, hTagStyleMap, headingContainer } from './Heading.css';
import type { PostHeadingProps } from './Heading.types';

export const PostHeading = ({ element, children, ...props }: PostHeadingProps) => {
  const { level = 1, textAlign } = element.attrs;
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div
      {...anchorAttributes}
      className={headingContainer}
      style={
        {
          '--text-align': textAlign,
        } as CSSProperties
      }
    >
      <Tag {...props} className={classNames(baseHeading, hTagStyleMap[`h${level}`])}>
        {children}
      </Tag>
    </div>
  );
};
